module.exports = __webpack_public_path__ + "img/banner_left.9bee8614.png";